<template>
  <section class="wide-highlight">
    <div class="hero-grid">
      <div class="hero-copy">
        <span class="kicker">{{ kicker }}</span>
        <h1>{{ title }}</h1>
        <p class="lead">{{ weakText }}</p>
        <div class="actions">
          <button class="btn primary" @click="goPrimary">{{ primaryLabel }}</button>
          <button class="btn ghost" @click="goSecondary">{{ secondaryLabel }}</button>
        </div>
      </div>
      <div class="hero-visual">
        <div class="visual-frame">
          <img :src="backgroundImage" alt="OCN görseli" class="highlight-image" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WideHighlight',
  props: {
    backgroundImage: {
      type: String,
      required: true
    },
    weakText: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Toprağa değer, üreticiye güven.'
    },
    kicker: {
      type: String,
      default: 'OCN Gübre'
    },
    primaryLabel: {
      type: String,
      default: 'Kurumsal'
    },
    secondaryLabel: {
      type: String,
      default: 'Ürünler'
    },
    primaryRoute: {
      type: String,
      default: '/kurumsal'
    },
    secondaryRoute: {
      type: String,
      default: '/urunler'
    },
    projectUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    goPrimary() {
      if (this.primaryRoute) {
        this.$router.push(this.primaryRoute);
      } else if (this.projectUrl) {
        window.open(this.projectUrl, '_blank');
      }
    },
    goSecondary() {
      if (this.secondaryRoute) {
        this.$router.push(this.secondaryRoute);
      } else if (this.projectUrl) {
        window.open(this.projectUrl, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.wide-highlight {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: radial-gradient(120% 120% at 10% 20%, rgba(34, 197, 94, 0.14), transparent),
    radial-gradient(120% 120% at 80% 10%, rgba(15, 118, 110, 0.14), transparent),
    linear-gradient(135deg, #f8fafc 0%, #e2f3eb 100%);
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 36px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.12);
}

.hero-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  align-items: center;
  gap: 28px;
}

.hero-copy {
  text-align: left;
  color: #0f172a;
  display: grid;
  gap: 12px;
}

.kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 800;
  color: #0f766e;
}

.kicker::before {
  content: '';
  width: 18px;
  height: 2px;
  background: #0f766e;
  border-radius: 999px;
}

h1 {
  font-size: clamp(28px, 5vw, 40px);
  margin: 0;
}

.lead {
  margin: 0;
  color: #1f2937;
  line-height: 1.6;
  max-width: 640px;
}

.actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.btn {
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 12px 18px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}

.btn.primary {
  background: #0f172a;
  color: #f8fafc;
  border-color: #0f172a;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);
}

.btn.primary:hover {
  transform: translateY(-2px);
  background: #0b1221;
}

.btn.ghost {
  background: rgba(255, 255, 255, 0.8);
  color: #0f172a;
  border-color: #cbd5e1;
}

.btn.ghost:hover {
  transform: translateY(-2px);
  border-color: #0f766e;
  color: #0f766e;
  background: #ecfdf3;
}

.hero-visual {
  position: relative;
  display: grid;
  place-items: center;
}

.visual-frame {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 16px 44px rgba(15, 23, 42, 0.12);
}

.highlight-image {
  display: block;
  max-width: min(440px, 100%);
  width: 100%;
  height: auto;
  object-fit: contain;
}

.chip {
  position: absolute;
  bottom: -12px;
  right: 22px;
  background: #0f766e;
  color: #f8fafc;
  padding: 10px 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 14px 32px rgba(15, 118, 110, 0.28);
}

@media (max-width: 900px) {
  .wide-highlight {
    padding: 28px;
  }

  .hero-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .hero-visual {
    justify-items: start;
  }

  .highlight-image {
    max-width: 320px;
  }
}

@media (max-width: 640px) {
  .wide-highlight {
    padding: 22px;
  }

  .actions {
    flex-direction: column;
  }

  .hero-copy {
    gap: 10px;
  }
}
</style>
